import {useId} from 'react'
import {CounterLabel} from '@primer/react'
import {Disclosure} from '@github-ui/disclosure'
import type {RegisteredRuleSchemaComponent} from '@github-ui/repos-rules-types/rules-types'
import {FilePathList} from './FilePathList'

import styles from './AllowedExceptions.module.css'

export function AllowedExceptions({field, value, onValueChange, readOnly}: RegisteredRuleSchemaComponent) {
  const exceptionsId = useId()
  const description = field.description
  const ignoredFilePaths = (value as string[] | undefined) ?? []

  return (
    <Disclosure defaultOpen={ignoredFilePaths.length > 0}>
      <Disclosure.Trigger className="mt-3">
        <div className={styles.triggerContents}>
          Allowed exceptions
          <CounterLabel>{ignoredFilePaths.length}</CounterLabel>
          <Disclosure.Chevron />
        </div>
      </Disclosure.Trigger>

      <Disclosure.Panel>
        {description && <span className={styles.descriptionText}>{description}</span>}
        <div id={exceptionsId} className="mt-3">
          <FilePathList
            field={field}
            value={value}
            onValueChange={onValueChange}
            readOnly={readOnly}
            boxName="Allowed exceptions"
            buttonName="Add allowed path"
            blankslate="No allowed paths"
          />
        </div>
      </Disclosure.Panel>
    </Disclosure>
  )
}
